import { useEffect, useState } from "react";
import { searchCities } from "../lib/cities";
import { Input } from "./ui/input";
import { MapPin } from "lucide-react";

export function CityInput({ value, onChange, onPick, province, testid, className = "", ...rest }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [hi, setHi] = useState(0);

  useEffect(() => {
    if (!open) return;
    let live = true;
    const city = (value || "").split(",")[0];
    searchCities(city, province).then((r) => { if (live) { setItems(r); setHi(0); } });
    return () => { live = false; };
  }, [value, province, open]);

  const pick = (c) => { onPick(c); setOpen(false); };
  const onKey = (e) => {
    rest.onKeyDown?.(e);
    if (!open || !items.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setHi((h) => (h + 1) % items.length); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setHi((h) => (h - 1 + items.length) % items.length); }
    else if (e.key === "Enter") { e.preventDefault(); pick(items[hi]); }
    else if (e.key === "Escape") setOpen(false);
  };

  return (
    <div className="relative">
      <Input {...rest} value={value} autoComplete="off" data-testid={testid} className={className}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 120)} onKeyDown={onKey} />
      {open && items.length > 0 && (
        <ul className="absolute z-50 mt-1 w-full max-h-64 overflow-auto rounded-xl border border-slate-200 bg-white shadow-lg py-1" data-testid={`${testid}-suggestions`}>
          {items.map((c, i) => (
            <li key={`${c.city}-${c.province}`}>
              <button type="button" onMouseDown={(e) => { e.preventDefault(); pick(c); }} onMouseEnter={() => setHi(i)}
                data-testid={`${testid}-option-${i}`}
                className={`w-full flex items-center gap-2 px-3 py-2 text-sm text-left transition-colors ${i === hi ? "bg-orange-50 text-[#12234A]" : "text-slate-700"}`}>
                <MapPin size={13} className="text-[#F5551E] shrink-0" />
                <span className="font-medium">{c.city}</span>
                <span className="ml-auto text-xs text-slate-400">{c.province}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
